import { Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../../../components/PageHeader';
import { PageContent, PageLayout } from '../../../../layout';
import { DataMapperModule } from '../../../../modules/data-mapper';
const TRANS_NS = 'universal-reminding';
export const DataMapperPage = () => {
  const { t } = useTranslation(TRANS_NS, { keyPrefix: 'data-mapper' });
  return (
    <PageLayout>
      <PageHeader backRouteTo={null} title={t('title')} />
      <PageContent sx={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}>
        <Paper sx={{ p: 2, position: 'relative', width: '100%', height: '100%' }}>
          <DataMapperModule />
        </Paper>
      </PageContent>
    </PageLayout>
  );
};
